import type { HTMLAttributes } from "react"
import { cn } from "cn"

interface ProgressBarProps extends HTMLAttributes<HTMLDivElement> {
  value: number
}

export function ProgressBar({ value, className, ...props }: ProgressBarProps) {
  const clampedValue = Math.min(100, Math.max(0, value))

  return (
    <div
      {...props}
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round(clampedValue)}
      className={cn("h-1.5 overflow-hidden bg-gray-4", className)}
    >
      <div
        className="h-full bg-foreground transition-all duration-300 ease-out"
        style={{ width: `${clampedValue}%` }}
      />
    </div>
  )
}
